import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const HomePage = () => {
  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 6, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);
  useEffect(() => {
    const swiper = new Swiper(".h3-testimonial-slider", {
      slidesPerView: 1,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 1, spaceBetween: 30 },
        992: { slidesPerView: 1, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  return (
    <main>
      <section className="w-full bg-white pt-[130px] sm:pt-[160px] pb-[70px] sm:pb-[80px] relative overflow-hidden">
        {/* content start */}
        <div className="w-full relative theme-container mx-auto grid grid-cols-6 xl:grid-cols-12 z-10">
          <div className="col-span-7 flex h-full items-center">
            <div className="h-fit">
              <h1 data-aos="fade-up" className="flex text-20 font-semibold text-main-black bg-it-blue/10 border border-it-blue/20 items-center gap-2.5 w-fit px-6 py-1 rounded-[40px]">
                <svg
                  width={21}
                  height={20}
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_460_29187)">
                    <path
                      d="M10.4996 10.9371L0.549805 7.62184C0.631053 7.4156 0.815423 7.26529 1.03417 7.23435L7.18714 6.32812L10.4996 10.9371Z"
                      fill="#5F57FF"
                    />
                    <path
                      d="M10.5002 10.937V16.6775L4.99725 19.6149C4.78475 19.7274 4.53195 19.709 4.33789 19.5649L10.5002 10.937Z"
                      fill="#5F57FF"
                    />
                    <path
                      d="M10.5005 10.937L4.33784 19.5646C4.14753 19.4243 4.05035 19.1837 4.09128 18.9431L5.14094 12.7248L10.5005 10.937Z"
                      fill="#5F57FF"
                    />
                    <path
                      d="M10.5 10.9368L5.14079 12.7246L0.690595 8.31813C0.519037 8.14938 0.456226 7.89595 0.531224 7.66814C0.537786 7.65252 0.540599 7.63658 0.550286 7.62158L10.5 10.9368Z"
                      fill="#5F57FF"
                    />
                    <path
                      d="M10.4999 0.312012V10.9367L7.1875 6.32748L9.94055 0.665128C10.0437 0.449196 10.2624 0.312012 10.4999 0.312012Z"
                      fill="#5F57FF"
                    />
                    <path
                      d="M13.8124 6.32748L10.5 10.9367V0.312012C10.7375 0.312012 10.9562 0.449196 11.0594 0.665128L13.8124 6.32748Z"
                      fill="#5F57FF"
                    />
                    <path
                      d="M20.4497 7.62167L10.5 10.9369L13.8124 6.32764L19.9654 7.23386C20.1841 7.26511 20.3685 7.41511 20.4497 7.62167Z"
                      fill="#5F57FF"
                    />
                    <path
                      d="M20.3123 8.31813L15.8592 12.7246L10.5 10.9368L20.4497 7.62158C20.4591 7.63689 20.4622 7.65283 20.4688 7.66814C20.5435 7.89626 20.481 8.14938 20.3123 8.31813Z"
                      fill="#5F57FF"
                    />
                    <path
                      d="M16.6623 19.5646L10.5 10.937L15.8592 12.7248L16.9092 18.9431C16.9498 19.184 16.853 19.4243 16.6623 19.5646Z"
                      fill="#5F57FF"
                    />
                    <path
                      d="M16.6623 19.5646C16.4686 19.7087 16.2155 19.7274 16.0033 19.6146L10.5 16.6775V10.937L16.6623 19.5646Z"
                      fill="#5F57FF"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_460_29187">
                      <rect
                        width={20}
                        height={20}
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                Truvana OPD
              </h1>
              <h1 data-aos="fade-up"
                data-aos-delay={100}
                className="text-4xl md:text-[65px] tracking-tight font-bold leading-[1.2em] text-main-black pr-2 max-w-[658px] mt-7"
                data-depth="-0.28"
              >
                Smarter Health Plans for Everyday Care
              </h1>
              <p data-aos="fade-up"
                data-aos-delay={200} className="text-[16px] font-semibold mt-4">
                Affordable, Accessible & Tailored OPD Coverage for You and Your
                Family
              </p>
              <p data-aos="fade-up"
                data-aos-delay={300} className="text-18 font-medium font-inter text-paragraph mt-5 md:mt-8 max-w-[571px]">
                At Truvana Health, we simplify your healthcare journey with
                smart OPD plans that fit your lifestyle. Whether it's doctor
                consultations, diagnostics, or preventive care — we’ve got you
                covered with flexible, transparent plans designed to keep you
                healthy and worry-free.
              </p>
              <div className="flex flex-col mb-20 sm:mb-0 sm:flex-row gap-3 sm:gap-6 mt-5 md:mt-10">
                <a data-aos="fade-up"
                data-aos-delay={400} href="/plans">
                  <div className="home-two-btn-bg py-2.5 group bg-[#1D109E] border-[#1D109E]">
                    <span className="text-base text-white group-hover:text-[#1D109E] transition-all duration-300 font-semibold font-inter py-1 relative z-10">
                      Explore Plans
                    </span>
                    <svg
                      className="relative z-10"
                      width={7}
                      height={12}
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className="group-hover:stroke-[#1D109E] stroke-white transition-all duration-300"
                        d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </a>
                <a data-aos="fade-up"
                data-aos-delay={500} href="/contact">
                  <div className="home-two-btn-bg py-2.5 group bg-[#ffffff] border-[#1D109E] before:bg-it-blue after:bg-it-blue">
                    <span className="text-base text-[#1D109E] group-hover:text-[#ffffff] transition-all duration-300 font-semibold font-inter py-1 relative z-10">
                      Talk to an Expert
                    </span>
                    <svg
                      className="relative z-10"
                      width={7}
                      height={12}
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className="group-hover:stroke-white stroke-[#1D109E] transition-all duration-300"
                        d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="col-span-5 mgtop">
            <img data-aos="fade" src="assets/images/hero1.png" alt="" className="" />
          </div>
        </div>
        {/* content end  */}
        <div data-aos="fade" className="w-fit h-fit absolute right-0 bottom-0 bg-it-blue">
          <img src="assets/images/home-seven/dot.svg" alt="" className="" />
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-[1616px] mx-auto">
          <div className="w-full pt-10 xl:pt-[80px]">
            <h1 className="w-full text-center font-medium text-black" data-aos="fade-up">
              We’ve more then 10+ trusted clients
            </h1>
            <center className="min-md:px-[200px]">
              <div
                className="swiper h3-partner_slider mt-11 overflow-hidden"
              >
                <div className="swiper-wrapper">
                  <div className="swiper-slide" data-aos="fade-up">
                    <img src="assets/images/partner_logo/1.svg" alt="" />
                  </div>
                  <div className="swiper-slide"data-aos="fade-up"
                data-aos-delay={100}>
                    <img src="assets/images/partner_logo/2.svg" alt="" />
                  </div>
                  <div className="swiper-slide" data-aos="fade-up"
                data-aos-delay={200}>
                    <img src="assets/images/partner_logo/4.svg" alt="" />
                  </div>
                  <div className="swiper-slide" data-aos="fade-up"
                data-aos-delay={300}>
                    <img src="assets/images/partner_logo/5.svg" alt="" />
                  </div>
                  <div className="swiper-slide"data-aos="fade-up"
                data-aos-delay={400}>
                    <img src="assets/images/partner_logo/6.svg" alt="" />
                  </div>
                  <div className="swiper-slide"data-aos="fade-up"
                data-aos-delay={500}>
                    <img src="assets/images/partner_logo/7.svg" alt="" />
                  </div>
                </div>
              </div>
            </center>
          </div>
        </div>
      </section>

      {/* about start  */}
      <section className="bg-white w-full py-16 md:pt-[130px] md:pb-[40px] overflow-hidden">
        <div className="theme-container w-full mx-auto">
          <div className="grid grid-cols-6 lg:grid-cols-12 gap-y-10">
            <div className="col-span-6">
              <h1
                data-aos="fade-up"
                data-aos-delay={100}
                className="border text-[#1D109E] border-[#1D109E25] py-0.5 px-5 rounded-[30px] w-fit bg-main-gray"
              >
                About Company
              </h1>
              <h2 data-aos="fade-up"
                data-aos-delay={200} className="text-24 sm:text-48 font-semibold text-black pt-5">
                The Truvana Way Where <br /> Truth Meets Nature — Wellness in
                Every Breath
              </h2>
            </div>
            <div className="col-span-6 flex flex-col lg:items-end">
              <div className="w-full max-w-[528px]">
                <h2 data-aos="fade-up"
                data-aos-delay={100} className="font-semibold sm:text-18 text-black">
                  At Truvana, we believe that the path to lasting wellness
                  begins with trust — trust in nature, in science, and in
                  ourselves. Our name reflects this philosophy: "Tru" stands for
                  truth and transparency, while "Vana", derived from the
                  Sanskrit word for forest, symbolizes nature, healing, and
                  renewal.
                </h2>
                <p data-aos="fade-up"
                data-aos-delay={200} className="text-paragraph leading-7 mt-2 pt-4 md:pt-9">
                  Truvana Health was born from the need to bridge with modern
                  wellness. We offer health products that are clean, honest, and
                  rooted in both tradition and innovation — empowering people to
                  live healthier, more balanced lives. We are more than just a
                  health brand — we are a movement toward mindful living,
                  conscious choices, and natural solutions that restore your
                  body’s true harmony. Truvana Health. - Wellness in Every
                  Breath
                </p>
                <Link to="/contact">
                  <div data-aos="fade-up"
                data-aos-delay={100} className="home-two-btn-bg py-3.5 group bg-[#1D109E] border-[#1D109E] w-fit mt-12">
                    <span className="text-base text-white group-hover:text-[#1D109E] transition-all duration-300 font-semibold font-inter relative z-10">
                      Contact Us
                    </span>
                    <svg
                      className="relative z-10"
                      width={7}
                      height={12}
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className="group-hover:stroke-[#1D109E] transition-all duration-300"
                        d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-12 gap-[30px] h3-about-card relative overflow-hidden w-full pt-10 md:pt-20"
          >
            {/* card start  */}
            <div data-aos="fade-up" className="col-span-3 relative flex flex-col justify-center items-center bg-main-gray border border-[#1D109E11] rounded-3xl pt-4 pb-4 md:pt-6 md:pb-6 overflow-hidden group">
              <div className="absolute top-0 left-0 z-0 overflow-hidden h-full -translate-x-96 group-hover:translate-x-0 transition-all duration-200 opacity-20">
                <img src="assets/images/home-three/about-card-bg.svg" alt="" />
              </div>
              <div className="relative z-10 flex justify-center items-center flex-col">
                <h1
                  className="text-48 text-main-black font-semibold pb-[18px]"
                  data-scroll-qs="scroll"
                  data-count-qs={15}
                  data-type-qs="K+"
                  data-speed-qs={1000}
                >
                  1.5k+
                </h1>
                <div className="w-20 border-2 border-[#1D109E]" />
                <p className="text-center font-semibold text-18 text-paragraph pt-6">
                  Doctors
                </p>
              </div>
            </div>
            {/* card end  */}
            {/* card start  */}
            <div data-aos="fade-up"
                data-aos-delay={100} className="col-span-3 relative flex flex-col justify-center items-center bg-main-gray border border-[#1D109E11] rounded-3xl pt-4 pb-4 md:pt-6 md:pb-6 overflow-hidden group">
              <div className="absolute top-0 left-0 z-0 overflow-hidden h-full -translate-x-96 group-hover:translate-x-0 transition-all duration-200 opacity-20">
                <img src="assets/images/home-three/about-card-bg.svg" alt="" />
              </div>
              <div className="relative z-10 flex justify-center items-center flex-col">
                <h1
                  className="text-48 text-main-black font-semibold pb-[18px]"
                  data-scroll-qs="scroll"
                  data-count-qs={10}
                  data-type-qs="K+"
                  data-speed-qs={1000}
                >
                  250+
                </h1>
                <div className="w-20 border-2 border-[#1D109E]" />
                <p className="text-center font-semibold text-18 text-paragraph pt-6">
                  Hospitals
                </p>
              </div>
            </div>
            {/* card end  */}
            {/* card start  */}
            <div data-aos="fade-up"
                data-aos-delay={200} className="col-span-3 relative flex flex-col justify-center items-center bg-main-gray border border-[#1D109E11] rounded-3xl pt-4 pb-4 md:pt-6 md:pb-6 overflow-hidden group">
              <div className="absolute top-0 left-0 z-0 overflow-hidden h-full -translate-x-96 group-hover:translate-x-0 transition-all duration-200 opacity-20">
                <img src="assets/images/home-three/about-card-bg.svg" alt="" />
              </div>
              <div className="relative z-10 flex justify-center items-center flex-col">
                <h1
                  className="text-48 text-main-black font-semibold pb-[18px]"
                  data-scroll-qs="scroll"
                  data-count-qs={28}
                  data-type-qs="K+"
                  data-speed-qs={1000}
                >
                  110+
                </h1>
                <div className="w-20 border-2 border-[#1D109E]" />
                <p className="text-center font-semibold text-18 text-paragraph pt-6">
                  Corporates & Associations
                </p>
              </div>
            </div>
            {/* card end  */}
            {/* card start  */}
            <div data-aos="fade-up"
                data-aos-delay={300} className="col-span-3 relative flex flex-col justify-center items-center bg-main-gray border border-[#1D109E11] rounded-3xl pt-4 pb-4 md:pt-6 md:pb-6 overflow-hidden group">
              <div className="absolute top-0 left-0 z-0 overflow-hidden h-full -translate-x-96 group-hover:translate-x-0 transition-all duration-200 opacity-20">
                <img src="assets/images/home-three/about-card-bg.svg" alt="" />
              </div>
              <div className="relative z-10 flex justify-center items-center flex-col">
                <h1
                  className="text-48 text-main-black font-semibold pb-[18px]"
                  data-scroll-qs="scroll"
                  data-count-qs={50}
                  data-type-qs="+"
                  data-speed-qs={1000}
                >
                  30K
                </h1>
                <div className="w-20 border-2 border-[#1D109E]" />
                <p className="text-center font-semibold text-18 text-paragraph pt-6">
                  Customers
                </p>
              </div>
            </div>
            {/* card end  */}
          </div>
        </div>
      </section>
      {/* about end  */}

      <section className="py-[70px] sm:pb-[60px] bg-white">
        <div className="theme-container mx-auto grid grid-cols-6 lg:grid-cols-12 sm:gap-[63px]">
          <div className="col-span-6">
            <h1 data-aos="fade-up" className="px-5 bg-main-gray border border-it-blue/20 text-it-blue font-medium rounded-[30px] w-fit">
              Mission | Vision | Core Values
            </h1>
            <h2 data-aos="fade-up"
                data-aos-delay={100} className="font-semibold text-2xl sm:text-48 text-main-black mt-5">
              Rooted in Nature. Built on Trust. Driven by Purpose.
            </h2>
            <ul className="mb-[30px] max-w-full">
              <li data-aos="fade-up"
                data-aos-delay={200} className="flex flex-col sm:flex-row gap-[30px] items-start mt-10">
                <div className="w-[30px] aspect-square rounded-full bg-it-blue flex items-center justify-center">
                  <svg
                    width={16}
                    height={11}
                    viewBox="0 0 16 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.6907 0.612031C15.1811 0.993484 15.2695 1.70029 14.888 2.19073L8.87753 9.91852C7.94196 11.1214 6.18214 11.2775 5.04945 10.2581L1.24742 6.83626C0.785601 6.42062 0.748162 5.70929 1.1638 5.24747C1.57945 4.78564 2.29077 4.7482 2.75259 5.16385L6.55462 8.58567C6.71643 8.7313 6.96783 8.709 7.10149 8.53716L13.112 0.809368C13.4934 0.318928 14.2003 0.230577 14.6907 0.612031Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <h1 className="text-main-black font-semibold text-20">
                    Our Mission
                  </h1>
                  <p className="text-paragraph max-w-[466px]">
                    To empower individuals with authentic, effective, and
                    accessible health solutions rooted in nature and enhanced by
                    science.
                  </p>
                </div>
              </li>
              <li data-aos="fade-up"
                data-aos-delay={300} className="flex flex-col sm:flex-row gap-[30px] items-start mt-6">
                <div className="w-[30px] aspect-square rounded-full bg-it-blue flex items-center justify-center">
                  <svg
                    width={16}
                    height={11}
                    viewBox="0 0 16 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.6907 0.612031C15.1811 0.993484 15.2695 1.70029 14.888 2.19073L8.87753 9.91852C7.94196 11.1214 6.18214 11.2775 5.04945 10.2581L1.24742 6.83626C0.785601 6.42062 0.748162 5.70929 1.1638 5.24747C1.57945 4.78564 2.29077 4.7482 2.75259 5.16385L6.55462 8.58567C6.71643 8.7313 6.96783 8.709 7.10149 8.53716L13.112 0.809368C13.4934 0.318928 14.2003 0.230577 14.6907 0.612031Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <h1 className="text-main-black font-semibold text-20">
                    Our Vision
                  </h1>
                  <p className="text-paragraph max-w-[466px]">
                    To become a trusted leader in wellness and outpatient
                    healthcare, setting new standards in transparency, efficacy,
                    and personalized care.
                  </p>
                </div>
              </li>
              <li data-aos="fade-up"
                data-aos-delay={400} className="flex flex-col sm:flex-row gap-[30px] items-start mt-6">
                <div className="w-[30px] aspect-square rounded-full bg-it-blue flex items-center justify-center">
                  <svg
                    width={16}
                    height={11}
                    viewBox="0 0 16 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.6907 0.612031C15.1811 0.993484 15.2695 1.70029 14.888 2.19073L8.87753 9.91852C7.94196 11.1214 6.18214 11.2775 5.04945 10.2581L1.24742 6.83626C0.785601 6.42062 0.748162 5.70929 1.1638 5.24747C1.57945 4.78564 2.29077 4.7482 2.75259 5.16385L6.55462 8.58567C6.71643 8.7313 6.96783 8.709 7.10149 8.53716L13.112 0.809368C13.4934 0.318928 14.2003 0.230577 14.6907 0.612031Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <h1 className="text-main-black font-semibold text-20">
                    Core Values
                  </h1>
                  <p className="text-paragraph max-w-[550px]">
                    • Integrity: Transparency in formulation, sourcing, and
                    communication <br></br>• Adaptability: Agile strategies to
                    evolve with changing health trends <br></br>• Science &
                    Nature: Merging modern clinical research with traditional
                    health wisdom<br></br> • Empowerment: Enabling people to
                    take charge of their own health
                  </p>
                </div>
              </li>
            </ul>
            <a href="/plans">
              <div data-aos="fade-up" className="home-two-btn-bg py-2.5 group bg-[#1D109E] border-[#1D109E]">
                <span className="text-base text-white group-hover:text-[#1D109E] transition-all duration-300 font-semibold font-inter py-1 relative z-10">
                  Explore Plans
                </span>
                <svg
                  className="relative z-10"
                  width={7}
                  height={12}
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="group-hover:stroke-[#1D109E] stroke-white transition-all duration-300"
                    d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </a>
          </div>
          <div className="col-span-6 mt-5 md:mt-0">
            <div className="flex w-full relative justify-end">
              <img data-aos="fade-up"
                src="assets/images/home-seven/business.png"
                alt=""
                className="max-w-full"
              />
              <div data-aos="fade-up"
                data-aos-delay={100} className="bg-it-blue p-4 sm:p-[30px] rounded-2xl absolute z-10 bottom-16 left-2 sm:left-0 w-48 sm:w-[295px]">
                <img
                  src="assets/images/home-five/hero/about-card-shape.webp"
                  alt=""
                  className="absolute right-2 top-bottom-moving"
                />
                <div className="flex items-center gap-2.5">
                  <svg
                    width={11}
                    height={12}
                    viewBox="0 0 11 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.28753 7.01343L8.90454 1.36956M8.90454 1.36956L3.26066 1.75255M8.90454 1.36956L1.01321 10.4099"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="text-sm text-white leading-8">We have</span>
                </div>
                <h1
                  className="text-[27px] leading-[35px] text-white font-semibold tracking-tight max-w-[170px]"
                  data-scroll-qs="scroll"
                  data-count-qs={5}
                  data-type-qs="+ Years of Experience"
                  data-speed-qs={1000}
                >
                  5+ Years of Experience
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials start  */}
      <section className="py-[70px] sm:py-[130px] bg-it-gray">
        <div className="theme-container w-full mx-auto">
          <div className="grid grid-cols-6 items-center lg:grid-cols-12 gap-y-10">
            <div className="col-span-6">
              <h1 data-aos="fade-up" className="border text-[#1D109E] border-[#1D109E11] py-0.5 px-5 rounded-[30px] w-fit bg-main-gray font-medium">
                Our Testimonials
              </h1>
              <h2 data-aos="fade-up"
                data-aos-delay={100} className="text-24 sm:text-48 font-semibold text-black pt-5 max-w-[457px]">
                Customer Say About Our Services
              </h2>
              <p data-aos="fade-up"
                data-aos-delay={200} className="text-18 text-paragraph pt-5">
                We’ve 1k+ Happy Customers
              </p>
              
            </div>
            <div className="col-span-6 flex flex-col items-start justify-start relative max-w-[502px]">
              <div data-aos="fade-up"
                data-aos-delay={100} className="swiper overflow-hidden h3-testimonial-slider w-full h-full">
                <div className="swiper-wrapper">
                  <div className="swiper-slide flex flex-col justify-between">
                    <div>
                      <div className="flex gap-6 items-center">
                        <div className="flex min-w-12 w-12 sm:w-[60px] min-h-12 h-12 sm:h-[60px] rounded-full overflow-hidden">
                          <img
                            className="w-full object-cover"
                            src="assets/images/vikram.png"
                            alt=""
                          />
                        </div>
                        <h1 className="text-20 font-semibold text-main-black">
                          Ashish Mehta,{" "}
                          <span className="text-sm font-medium text-paragraph">
                            Bangalore
                          </span>
                        </h1>
                      </div>
                      <h1 className="text-[16px] text-paragraph pt-[30px]">
                        The customer support is exceptional, and the platform is
                        so easy to use. I feel confident knowing my health is in
                        good hands.
                      </h1>
                    </div>
                    <div className="flex justify-between items-center mt-5 md:mt-10">
                      <svg
                        width={54}
                        height={40}
                        viewBox="0 0 54 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M49.5406 4.06287C47.1408 1.36698 44.2282 0 40.8838 0C37.8781 0 35.33 1.07033 33.3098 3.18112C31.3024 5.27842 30.2845 7.88345 30.2845 10.924C30.2845 13.7974 31.3127 16.3578 33.3404 18.5344C35.129 20.4545 37.3822 21.6759 40.0496 22.1736C39.5831 25.7101 36.4568 28.9111 30.7387 31.7003L29.709 32.2026L33.9307 39.9964L34.8837 39.5134C46.976 33.3839 53.1072 24.7214 53.1072 13.7664C53.1072 9.98687 51.9073 6.72226 49.5406 4.06287ZM34.8388 37.062L32.7236 33.1576C39.0843 29.8246 42.3069 25.8181 42.3069 21.2372V20.2564L41.3324 20.146C38.7077 19.849 36.6191 18.8322 34.9474 17.0374C33.2877 15.2557 32.4808 13.2562 32.4808 10.924C32.4808 8.43381 33.2711 6.39791 34.8964 4.69953C36.5086 3.01495 38.4672 2.19605 40.8839 2.19605C43.6124 2.19605 45.9074 3.28432 47.9 5.5229C49.9262 7.79943 50.9111 10.4958 50.9111 13.7663C50.9111 18.7872 49.4973 23.3202 46.7091 27.2392C44.0485 30.9785 40.0582 34.2797 34.8388 37.062Z"
                          fill="#794AFF"
                        />
                        <path
                          d="M19.7738 4.0579C17.3473 1.36532 14.4226 0 11.0807 0C8.07213 0 5.53555 1.0723 3.54187 3.18703C1.5653 5.2835 0.563015 7.88657 0.563015 10.924C0.563015 13.7973 1.59113 16.3577 3.61863 18.5344C5.40351 20.4504 7.62964 21.6706 10.2474 22.1706C9.78658 25.7098 6.68627 28.9124 1.01401 31.7021L0 32.2006L4.1166 40L5.07906 39.5144C17.2262 33.3852 23.3853 24.7223 23.3853 13.7663C23.3852 9.98387 22.17 6.71749 19.7738 4.0579ZM5.04711 37.0583L2.98964 33.1599C9.30416 29.8257 12.5037 25.8182 12.5037 21.2371V20.2585L11.5314 20.1463C8.96052 19.8496 6.89766 18.8327 5.22542 17.0373C3.56573 15.2558 2.75906 13.2561 2.75906 10.924C2.75906 8.4306 3.53782 6.39252 5.13964 4.69362C6.72402 3.01308 8.6675 2.19605 11.0807 2.19605C13.8119 2.19605 16.122 3.28588 18.1422 5.52798C20.1925 7.80328 21.1892 10.4981 21.1892 13.7663C21.1892 18.7864 19.7692 23.3188 16.9683 27.2374C14.2963 30.9756 10.2888 34.2763 5.04711 37.0583Z"
                          fill="#794AFF"
                        />
                      </svg>
                      <div className="flex gap-2 sm:gap-4 items-center">
                        <h1 className="text-18 font-semibold text-main-black">
                          Effortless healthcare
                        </h1>
                        <div className="flex gap-1 sm:gap-2.5">
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide flex flex-col justify-between">
                    <div>
                      <div className="flex gap-6 items-center">
                        <div className="flex min-w-12 w-12 sm:w-[60px] min-h-12 h-12 sm:h-[60px] rounded-full overflow-hidden">
                          <img
                            className="w-full object-cover"
                            src="assets/images/karan.png"
                            alt=""
                          />
                        </div>
                        <h1 className="text-20 font-semibold text-main-black">
                          Rahul Gupta,{" "}
                          <span className="text-sm font-medium text-paragraph">
                            Chandigarh
                          </span>
                        </h1>
                      </div>
                      <h1 className="text-[16px] text-paragraph pt-[30px]">
                        I’m impressed by their dedication to making healthcare
                        affordable. Their OPD plans fit perfectly within my
                        budget, without compromising quality.
                      </h1>
                    </div>
                    <div className="flex justify-between items-center mt-5 sm:mt-10">
                      <svg
                        width={54}
                        height={40}
                        viewBox="0 0 54 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M49.5406 4.06287C47.1408 1.36698 44.2282 0 40.8838 0C37.8781 0 35.33 1.07033 33.3098 3.18112C31.3024 5.27842 30.2845 7.88345 30.2845 10.924C30.2845 13.7974 31.3127 16.3578 33.3404 18.5344C35.129 20.4545 37.3822 21.6759 40.0496 22.1736C39.5831 25.7101 36.4568 28.9111 30.7387 31.7003L29.709 32.2026L33.9307 39.9964L34.8837 39.5134C46.976 33.3839 53.1072 24.7214 53.1072 13.7664C53.1072 9.98687 51.9073 6.72226 49.5406 4.06287ZM34.8388 37.062L32.7236 33.1576C39.0843 29.8246 42.3069 25.8181 42.3069 21.2372V20.2564L41.3324 20.146C38.7077 19.849 36.6191 18.8322 34.9474 17.0374C33.2877 15.2557 32.4808 13.2562 32.4808 10.924C32.4808 8.43381 33.2711 6.39791 34.8964 4.69953C36.5086 3.01495 38.4672 2.19605 40.8839 2.19605C43.6124 2.19605 45.9074 3.28432 47.9 5.5229C49.9262 7.79943 50.9111 10.4958 50.9111 13.7663C50.9111 18.7872 49.4973 23.3202 46.7091 27.2392C44.0485 30.9785 40.0582 34.2797 34.8388 37.062Z"
                          fill="#794AFF"
                        />
                        <path
                          d="M19.7738 4.0579C17.3473 1.36532 14.4226 0 11.0807 0C8.07213 0 5.53555 1.0723 3.54187 3.18703C1.5653 5.2835 0.563015 7.88657 0.563015 10.924C0.563015 13.7973 1.59113 16.3577 3.61863 18.5344C5.40351 20.4504 7.62964 21.6706 10.2474 22.1706C9.78658 25.7098 6.68627 28.9124 1.01401 31.7021L0 32.2006L4.1166 40L5.07906 39.5144C17.2262 33.3852 23.3853 24.7223 23.3853 13.7663C23.3852 9.98387 22.17 6.71749 19.7738 4.0579ZM5.04711 37.0583L2.98964 33.1599C9.30416 29.8257 12.5037 25.8182 12.5037 21.2371V20.2585L11.5314 20.1463C8.96052 19.8496 6.89766 18.8327 5.22542 17.0373C3.56573 15.2558 2.75906 13.2561 2.75906 10.924C2.75906 8.4306 3.53782 6.39252 5.13964 4.69362C6.72402 3.01308 8.6675 2.19605 11.0807 2.19605C13.8119 2.19605 16.122 3.28588 18.1422 5.52798C20.1925 7.80328 21.1892 10.4981 21.1892 13.7663C21.1892 18.7864 19.7692 23.3188 16.9683 27.2374C14.2963 30.9756 10.2888 34.2763 5.04711 37.0583Z"
                          fill="#794AFF"
                        />
                      </svg>
                      <div className="flex gap-2 sm:gap-4 items-center">
                        <h1 className="text-18 font-semibold text-main-black">
                          Doctor in minutes
                        </h1>
                        <div className="flex gap-1 sm:gap-2.5">
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide flex flex-col justify-between">
                    <div>
                      <div className="flex gap-6 items-center">
                        <div className="flex min-w-12 w-12 sm:w-[60px] min-h-12 h-12 sm:h-[60px] rounded-full overflow-hidden">
                          <img
                            className="w-full object-cover"
                            src="assets/images/sneha.png"
                            alt=""
                          />
                        </div>
                        <h1 className="text-20 font-semibold text-main-black">
                          Neha Gujral,{" "}
                          <span className="text-sm font-medium text-paragraph">
                            Jaipur
                          </span>
                        </h1>
                      </div>
                      <h1 className="text-[16px] text-paragraph pt-[30px]">
                        Their OPD coverage is a lifesaver. I’ve saved so much on
                        regular doctor visits and diagnostic tests. Thank you
                        for this amazing service!
                      </h1>
                    </div>
                    <div className="flex justify-between items-center mt-5 sm:mt-10">
                      <svg
                        width={54}
                        height={40}
                        viewBox="0 0 54 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M49.5406 4.06287C47.1408 1.36698 44.2282 0 40.8838 0C37.8781 0 35.33 1.07033 33.3098 3.18112C31.3024 5.27842 30.2845 7.88345 30.2845 10.924C30.2845 13.7974 31.3127 16.3578 33.3404 18.5344C35.129 20.4545 37.3822 21.6759 40.0496 22.1736C39.5831 25.7101 36.4568 28.9111 30.7387 31.7003L29.709 32.2026L33.9307 39.9964L34.8837 39.5134C46.976 33.3839 53.1072 24.7214 53.1072 13.7664C53.1072 9.98687 51.9073 6.72226 49.5406 4.06287ZM34.8388 37.062L32.7236 33.1576C39.0843 29.8246 42.3069 25.8181 42.3069 21.2372V20.2564L41.3324 20.146C38.7077 19.849 36.6191 18.8322 34.9474 17.0374C33.2877 15.2557 32.4808 13.2562 32.4808 10.924C32.4808 8.43381 33.2711 6.39791 34.8964 4.69953C36.5086 3.01495 38.4672 2.19605 40.8839 2.19605C43.6124 2.19605 45.9074 3.28432 47.9 5.5229C49.9262 7.79943 50.9111 10.4958 50.9111 13.7663C50.9111 18.7872 49.4973 23.3202 46.7091 27.2392C44.0485 30.9785 40.0582 34.2797 34.8388 37.062Z"
                          fill="#794AFF"
                        />
                        <path
                          d="M19.7738 4.0579C17.3473 1.36532 14.4226 0 11.0807 0C8.07213 0 5.53555 1.0723 3.54187 3.18703C1.5653 5.2835 0.563015 7.88657 0.563015 10.924C0.563015 13.7973 1.59113 16.3577 3.61863 18.5344C5.40351 20.4504 7.62964 21.6706 10.2474 22.1706C9.78658 25.7098 6.68627 28.9124 1.01401 31.7021L0 32.2006L4.1166 40L5.07906 39.5144C17.2262 33.3852 23.3853 24.7223 23.3853 13.7663C23.3852 9.98387 22.17 6.71749 19.7738 4.0579ZM5.04711 37.0583L2.98964 33.1599C9.30416 29.8257 12.5037 25.8182 12.5037 21.2371V20.2585L11.5314 20.1463C8.96052 19.8496 6.89766 18.8327 5.22542 17.0373C3.56573 15.2558 2.75906 13.2561 2.75906 10.924C2.75906 8.4306 3.53782 6.39252 5.13964 4.69362C6.72402 3.01308 8.6675 2.19605 11.0807 2.19605C13.8119 2.19605 16.122 3.28588 18.1422 5.52798C20.1925 7.80328 21.1892 10.4981 21.1892 13.7663C21.1892 18.7864 19.7692 23.3188 16.9683 27.2374C14.2963 30.9756 10.2888 34.2763 5.04711 37.0583Z"
                          fill="#794AFF"
                        />
                      </svg>
                      <div className="flex gap-2 sm:gap-4 items-center">
                        <h1 className="text-18 font-semibold text-main-black">
                          Super fast service
                        </h1>
                        <div className="flex gap-1 sm:gap-2.5">
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide flex flex-col justify-between">
                    <div>
                      <div className="flex gap-6 items-center">
                        <div className="flex min-w-12 w-12 sm:w-[60px] min-h-12 h-12 sm:h-[60px] rounded-full overflow-hidden">
                          <img
                            className="w-full object-cover"
                            src="assets/images/pooja.png"
                            alt=""
                          />
                        </div>
                        <h1 className="text-20 font-semibold text-main-black">
                          Pooja Verma,{" "}
                          <span className="text-sm font-medium text-paragraph">
                            Delhi
                          </span>
                        </h1>
                      </div>
                      <h1 className="text-[16px] text-paragraph pt-[30px]">
                        From consultations to diagnostics, everything is
                        hassle-free. It’s so convenient, especially when you
                        have kids at home.
                      </h1>
                    </div>
                    <div className="flex justify-between items-center mt-5 sm:mt-10">
                      <svg
                        width={54}
                        height={40}
                        viewBox="0 0 54 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M49.5406 4.06287C47.1408 1.36698 44.2282 0 40.8838 0C37.8781 0 35.33 1.07033 33.3098 3.18112C31.3024 5.27842 30.2845 7.88345 30.2845 10.924C30.2845 13.7974 31.3127 16.3578 33.3404 18.5344C35.129 20.4545 37.3822 21.6759 40.0496 22.1736C39.5831 25.7101 36.4568 28.9111 30.7387 31.7003L29.709 32.2026L33.9307 39.9964L34.8837 39.5134C46.976 33.3839 53.1072 24.7214 53.1072 13.7664C53.1072 9.98687 51.9073 6.72226 49.5406 4.06287ZM34.8388 37.062L32.7236 33.1576C39.0843 29.8246 42.3069 25.8181 42.3069 21.2372V20.2564L41.3324 20.146C38.7077 19.849 36.6191 18.8322 34.9474 17.0374C33.2877 15.2557 32.4808 13.2562 32.4808 10.924C32.4808 8.43381 33.2711 6.39791 34.8964 4.69953C36.5086 3.01495 38.4672 2.19605 40.8839 2.19605C43.6124 2.19605 45.9074 3.28432 47.9 5.5229C49.9262 7.79943 50.9111 10.4958 50.9111 13.7663C50.9111 18.7872 49.4973 23.3202 46.7091 27.2392C44.0485 30.9785 40.0582 34.2797 34.8388 37.062Z"
                          fill="#794AFF"
                        />
                        <path
                          d="M19.7738 4.0579C17.3473 1.36532 14.4226 0 11.0807 0C8.07213 0 5.53555 1.0723 3.54187 3.18703C1.5653 5.2835 0.563015 7.88657 0.563015 10.924C0.563015 13.7973 1.59113 16.3577 3.61863 18.5344C5.40351 20.4504 7.62964 21.6706 10.2474 22.1706C9.78658 25.7098 6.68627 28.9124 1.01401 31.7021L0 32.2006L4.1166 40L5.07906 39.5144C17.2262 33.3852 23.3853 24.7223 23.3853 13.7663C23.3852 9.98387 22.17 6.71749 19.7738 4.0579ZM5.04711 37.0583L2.98964 33.1599C9.30416 29.8257 12.5037 25.8182 12.5037 21.2371V20.2585L11.5314 20.1463C8.96052 19.8496 6.89766 18.8327 5.22542 17.0373C3.56573 15.2558 2.75906 13.2561 2.75906 10.924C2.75906 8.4306 3.53782 6.39252 5.13964 4.69362C6.72402 3.01308 8.6675 2.19605 11.0807 2.19605C13.8119 2.19605 16.122 3.28588 18.1422 5.52798C20.1925 7.80328 21.1892 10.4981 21.1892 13.7663C21.1892 18.7864 19.7692 23.3188 16.9683 27.2374C14.2963 30.9756 10.2888 34.2763 5.04711 37.0583Z"
                          fill="#794AFF"
                        />
                      </svg>
                      <div className="flex gap-2 sm:gap-4 items-center">
                        <h1 className="text-18 font-semibold text-main-black">
                          Seamless experience
                        </h1>
                        <div className="flex gap-1 sm:gap-2.5">
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials end  */}
    </main>
  );
};

export default HomePage;
